import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {loadAllAxis} from "../../axis/all-axis/axisAction";
import styled from "styled-components";
import {getImage, getRandomKeyForChild} from "../../../utils/utils";
import axisSvg from "../../../images/axis/axis.svg";
import AxisFormForCoach from "./form/AxisFormForCoach";
import Assistant from "../Assistant";
import StrategyFormForCoach from "./form/StrategyFormForCoach";
import {loadOneAxis} from "../../axis/one-axis/oneAxisAction";
import Swot from "../../swot/Swot";
import StakeFormForCoach from "./form/StakeFormForCoach";
import ProjectFormForCoach from "./form/ProjectFormForCoach";
import {loadStrategy} from "../../strategy/strategyAction";
import projectLogo from "../../../images/nav/rocket.svg"
import subTarget from "../../../images/sub_target.svg"
import ValuesIcon from "../../../images/valuesIcon.png"
import MissionIcon from "../../../images/MissionIcon.png"
import VisionIcon from "../../../images/visionIcon.png"
import AmbitionIcon from "../../../images/ambitionIcon.png"
import placeholder from "../../../images/placeholderCoachEnjoy.png"
import {loadProject} from "../../project/one-project/projectAction";
import {CLEAR_PROJECT} from "../../project/actionsType";


const CoachEnjoyAnswer = ({question, close, adjust, setQuestion}) => {
    const {axis} = useSelector(state => state.axis)
    const project = useSelector(state => state.project)
    const strategy = useSelector(state => state.strategy)
    const dispatch = useDispatch()
    const strategicAxis = axis.filter(a => a.isStrategic === true)
    const [selectedAxis, setSelectedAxis] = useState({})
    const [selectedStake, setSelectedStake] = useState({})
    const [selectedProject, setSelectedProject] = useState({})
    const [axisFromCoach, setAxisFromCoach] = useState({name:"", comment:""})
    const [stakeFromCoach, setStakeFromCoach] = useState({})
    const [projectFromCoach, setProjectFromCoach] = useState({name:"", comment:""})
    const [success, setSuccess] = useState("")
    const [duty, setDuty] = useState("")
    const [vision, setVision] = useState("")
    const [goal, setGoal] = useState("")
    const [closeAssistant, setCloseAssistant] = useState()
    const [launch, setLaunch] = useState(false)

    const strength = selectedAxis?.swots?.filter(s => s.type === "strength")
    const weakness = selectedAxis?.swots?.filter(s => s.type === "weakness")
    const opportunity = selectedAxis?.swots?.filter(s => s.type === "opportunity")
    const threat = selectedAxis?.swots?.filter(s => s.type === "threat")

    const selectAxis = async (item) => {
        setSelectedAxis(item)
        await dispatch(loadOneAxis(item.id))
    }

    const selectProject = async (item) => {
        setSelectedProject(item)
        await dispatch(loadProject(item.id))
    }

    const closeTest = () => {
        setLaunch(false)
        close()
    }
    useEffect(() => {
        dispatch(loadAllAxis())
        dispatch(loadStrategy())
    }, [dispatch]);


    useEffect(() => {
        setSelectedAxis({})
        setSelectedStake({})
        setSelectedProject({})
        setLaunch(false)
    },[question])
    useEffect(() => {
        dispatch({type: CLEAR_PROJECT})
    }, [question,selectedProject]);

    useEffect(() => {
        dispatch(loadAllAxis())
    },[launch])
    return (
        <AnswerContainer>
             {
                question === "" &&
                <PlaceholderCoachEnjoy>
                    <h2> Comment puis-je à présent vous aider ?</h2>
                    <img className={"img-placeholder"} src={placeholder} alt=""/>
                </PlaceholderCoachEnjoy>
            }

            {
                question === "strategicAxis" &&
                <>
                    <Assistant
                        context={{object: "axis"}}
                        onSelect={(item) => {
                            setAxisFromCoach(prevState => {
                                let axis = {...prevState.axis};
                                axis.name = item.name;
                                axis.comment = item.description;
                                return axis
                            })
                        }}
                        fromCoach={true}
                        setClose={setCloseAssistant}
                        adjust={adjust}
                    />
                    {
                        closeAssistant &&
                        <AxisFormForCoach close={closeTest} selectedId={0} name={axisFromCoach.name}
                                          comment={axisFromCoach.comment}/>
                    }
                </>
            }
            {
                (question !== "" && question !== "strategicAxis" && question !== "VMVA" && question !== "success" && question !== "duty" && question !== "vision" && question !== "goal") && !selectedAxis.id &&
                <div>
                    <Questions>Pour quel axe ?</Questions>
                    {
                        strategicAxis?.map(a => {
                            return (
                                <AnswerItem key={"AxisItem" + a.id + getRandomKeyForChild()} onClick={() => {
                                    selectAxis(a)
                                }}>
                                    <img src={getImage(a.image, axisSvg)}
                                         alt={a.name}/>
                                    <p>{a.name}</p>
                                </AnswerItem>
                            )
                        })
                    }
                </div>
            }
            {
                selectedAxis.id && !selectedStake.id &&
                <>
                    <AnswerItem>
                        <h1 onClick={() => {
                            setSelectedAxis({})
                        }}>&#8592;</h1>
                        <img src={getImage(selectedAxis.image, axisSvg)} alt={selectedAxis.name}/>
                        <h2>{selectedAxis.name}</h2>
                    </AnswerItem>
                    {
                        question === "SWOT" &&
                        <>
                            <Swot entity={"axis"} fromCoach={true} adjust={adjust}/>
                        </>

                    }

                    {
                        question === "stake" &&
                        <>
                            {
                                launch ?
                                    <>
                                        <Assistant
                                            context={{
                                                object: "stake",
                                                axis: selectedAxis.name,
                                                weakness: selectedAxis.swots
                                                    .filter((item) => item.type === "weakness")
                                                    .map((item) => item.content),
                                                threat: selectedAxis.swots
                                                    .filter((item) => item.type === "threat")
                                                    .map((item) => item.content),
                                            }}
                                            onSelect={(item) => {
                                                setStakeFromCoach(item.name);
                                            }}
                                            setClose={setCloseAssistant}
                                            adjust={adjust}
                                            fromCoach={true}
                                        />
                                        {
                                            closeAssistant &&
                                            <StakeFormForCoach content={stakeFromCoach} axisId={selectedAxis.id}
                                                               close={closeTest}/>
                                        }
                                    </> :
                                    <AnswerItemContainer>
                                        {
                                            selectedAxis.stakes.length === 0 ?
                                                <AnswerItem>
                                                    <p>Aucun élément pour l'instant</p>
                                                </AnswerItem>
                                                :
                                                <AnswerItem>
                                                    <p>Enjeu(x) existant(s) :</p>
                                                </AnswerItem>
                                        }
                                        {
                                            selectedAxis.stakes.map(s => {
                                                return <AnswerItem>
                                                    <img src={subTarget} alt=""/>
                                                    <p> {s.name} </p>
                                                </AnswerItem>
                                            })}
                                        <LaunchButton onClick={() => {
                                            setLaunch(true)
                                        }}> Lancer le Coach Enjoy </LaunchButton>
                                    </AnswerItemContainer>
                            }

                        </>


                    }
                    {
                        (question === "project" || question === "improveAxis" || question === "projectAnalysis" || question === "improveProject") && !selectedStake.id &&
                        <>
                            <Questions>Pour quel Enjeu ?</Questions>
                            {
                                selectedAxis.stakes.length === 0 ?
                                    <AnswerItem>
                                        <p>Aucun élément pour l'instant</p>
                                    </AnswerItem>
                                    :
                                    ""
                            }
                            {
                                selectedAxis.stakes.map(s => {
                                    return <AnswerItem key={"StakeItem" + s.id + getRandomKeyForChild()}
                                                       onClick={() => {
                                                           setSelectedStake(s)
                                                       }}>
                                        <img src={subTarget} alt=""/>
                                        <p>{s.name}</p>
                                    </AnswerItem>
                                })
                            }
                        </>
                    }
                    {
                        question === "axisAnalysis" &&
                        <>
                            <Assistant
                                context={{
                                    object: "axis_analysis",
                                    axis: selectedAxis.name,
                                    axisDescription: selectedAxis.comment,
                                    weakness: selectedAxis.swots
                                        .filter((swot) => swot.type === "weakness")
                                        .map((swot) => swot.content),
                                    threats: selectedAxis.swots
                                        .filter((swot) => swot.type === "threat")
                                        .map((swot) => swot.content),
                                    strength: selectedAxis.swots
                                        .filter((swot) => swot.type === "strength")
                                        .map((swot) => swot.content),
                                    opportunity: selectedAxis.swots
                                        .filter((swot) => swot.type === "opportunity")
                                        .map((swot) => swot.content),
                                    projects: selectedAxis.stakes
                                        .map((s) => s.projects.map((p) => p.name))
                                        .flat(),
                                }}
                                adjust={adjust}
                                fromCoach={true}
                                setClose={setCloseAssistant}
                            />
                        </>
                    }
                </>

            }
            {
                selectedStake.id && !selectedProject.id &&
                <>
                    <AnswerItem>
                        <h1 onClick={() => {
                            setSelectedStake({})
                        }}>&#8592;</h1>
                        <img src={subTarget} alt=""/>
                        <h2>{selectedStake.name}</h2>
                    </AnswerItem>
                    <>
                        {
                            (question === "project" || question === "improveAxis") &&
                            <>
                                {
                                    launch ?
                                        <>
                                            {question === "project" &&
                                                <>
                                                    <Assistant
                                                        context={{
                                                            object: "project",
                                                            stake: selectedStake.name,
                                                            weakness: selectedAxis.swots
                                                                .filter((item) => item.type === "weakness")
                                                                .map((item) => item.content),
                                                            threat: selectedAxis.swots
                                                                .filter((item) => item.type === "threat")
                                                                .map((item) => item.content),
                                                            strength: selectedAxis.swots
                                                                .filter((item) => item.type === "strength")
                                                                .map((item) => item.content),
                                                            opportunity: selectedAxis.swots
                                                                .filter((item) => item.type === "opportunity")
                                                                .map((item) => item.content),
                                                        }}
                                                        onSelect={(item) => {
                                                            setProjectFromCoach(prevState => {
                                                                let project = {...prevState.project};
                                                                project.name = item.name;
                                                                project.comment = item.description;
                                                                return project
                                                            })

                                                        }}
                                                        adjust={adjust}
                                                        setClose={setCloseAssistant}
                                                        fromCoach={true}
                                                    />
                                                    {
                                                        closeAssistant &&
                                                        <ProjectFormForCoach close={closeTest}
                                                                             stakeId={selectedStake.id}
                                                                             projectFromCoach={projectFromCoach}/>
                                                    }
                                                </>
                                            }
                                            {
                                                question === "improveAxis" &&
                                                <>
                                                    <Assistant
                                                        context={{
                                                            object: "improveAxis",
                                                            axis: selectedAxis.name,
                                                            stake: selectedStake.name,
                                                            weakness: selectedAxis.swots
                                                                .filter((item) => item.type === "weakness")
                                                                .map((item) => item.content),
                                                            threat: selectedAxis.swots
                                                                .filter((item) => item.type === "threat")
                                                                .map((item) => item.content),
                                                            strength: selectedAxis.swots
                                                                .filter((item) => item.type === "strength")
                                                                .map((item) => item.content),
                                                            opportunity: selectedAxis.swots
                                                                .filter((item) => item.type === "opportunity")
                                                                .map((item) => item.content),
                                                        }}
                                                        onSelect={(item) => {
                                                            setProjectFromCoach(prevState => {
                                                                let project = {...prevState.project};
                                                                project.name = item.name;
                                                                project.comment = item.description;
                                                                return project
                                                            })
                                                        }}
                                                        adjust={adjust}
                                                        setClose={setCloseAssistant}
                                                        fromCoach={true}
                                                    />
                                                    {
                                                        closeAssistant &&
                                                        <ProjectFormForCoach close={closeTest}
                                                                             projectFromCoach={projectFromCoach}/>
                                                    }
                                                </>

                                            }
                                        </>

                                        :
                                        <>
                                            <AnswerItemContainer>
                                                {
                                                    selectedStake.projects.length === 0 ?
                                                        <AnswerItem>
                                                            <p>Aucun élément pour l'instant</p>
                                                        </AnswerItem>
                                                        :
                                                        <AnswerItem>
                                                            <p>Projet(s) existant(s) :</p>
                                                        </AnswerItem>
                                                }
                                                {selectedStake.projects.map(p => {
                                                    return <AnswerItem>
                                                        <img src={projectLogo} alt=""/>
                                                        <p> {p.name} </p>
                                                    </AnswerItem>
                                                })}
                                                <LaunchButton onClick={() => {
                                                    setLaunch(true)
                                                }}> Lancer le Coach Enjoy </LaunchButton>
                                            </AnswerItemContainer>
                                        </>
                                }
                            </>
                        }
                        {
                            (question === "projectAnalysis" || question === "improveProject") &&

                            <>

                                <>
                                    <Questions>Pour quel Projet ?</Questions>
                                    {
                                        selectedStake.projects.length === 0 ?
                                            <AnswerItem>
                                                <p>Aucun élément pour l'instant</p>
                                            </AnswerItem>
                                            :
                                            ""
                                    }
                                    {
                                        selectedStake.projects.map(p => {
                                            return <AnswerItem key={"ProjectItem" + p.id + getRandomKeyForChild()}
                                                               onClick={() => {
                                                                   selectProject(p)
                                                               }}>
                                                <img src={subTarget} alt=""/>
                                                <p>{p.name}</p>
                                            </AnswerItem>
                                        })
                                    }
                                </>
                            </>
                        }

                    </>
                </>

            }
            {
                selectedProject.id && project.id !== 0 &&
                <>
                    <AnswerItem>
                        <h1 onClick={() => {
                            setSelectedProject({})
                        }}>&#8592;</h1>
                        <img src={subTarget} alt=""/>
                        <h2>{selectedProject.name}</h2>
                    </AnswerItem>
                    {question === "projectAnalysis" &&
                        <Assistant
                            context={{
                                object: "project_analysis",
                                axis: selectedAxis.name,
                                axisDescription: selectedAxis.comment,
                                project: project.name,
                                projectDescription: project.comment,
                                weakness: project.swot
                                    .filter((swot) => swot.type === "weakness")
                                    .map((swot) => swot.content),
                                threats: project.swot
                                    .filter((swot) => swot.type === "threat")
                                    .map((swot) => swot.content),
                                strength: project.swot
                                    .filter((swot) => swot.type === "strength")
                                    .map((swot) => swot.content),
                                opportunity: project.swot
                                    .filter((swot) => swot.type === "opportunity")
                                    .map((swot) => swot.content),
                                objectives: project.objectives
                                    .map(o => o.title).flat(),
                                actions: project.actions
                                    .map(a => a.name).flat(),
                            }}
                            adjust={adjust}
                            fromCoach={true}
                            setClose={setCloseAssistant}
                        />
                    }
                    {
                        question === "improveProject" &&

                        <Assistant
                            context={{
                                object: "improveProject",
                                project: project.name,
                                projectDescription: project.comment
                            }}
                            adjust={adjust}
                            setClose={setCloseAssistant}
                            fromCoach={true}
                        />
                    }
                </>
            }
            {
                question === "VMVA" &&

                <VMVAContainer>
                    <VMVAItem onClick={() => {
                        setQuestion("success")
                    }}>
                        <img src={ValuesIcon} alt=""/>
                        <p>Valeurs</p>
                    </VMVAItem>
                    <VMVAItem onClick={() => {
                        setQuestion("duty")
                    }}>
                        <img src={MissionIcon} alt=""/>
                        <p>Mission</p>
                    </VMVAItem>
                    <VMVAItem onClick={() => {
                        setQuestion("vision")
                    }}>
                        <img src={VisionIcon} alt=""/>
                        <p>Vision</p>
                    </VMVAItem>
                    <VMVAItem onClick={() => {
                        setQuestion("goal")
                    }}>
                        <img src={AmbitionIcon} alt=""/>
                        <p>Ambition</p>
                    </VMVAItem>
                </VMVAContainer>
            }
            {
                question === "success" &&

                <VMVA>
                    <AnswerItem>
                        <h1 onClick={() => {
                            setQuestion("VMVA")
                        }}>&#8592;</h1>
                        <h2> Valeurs </h2>
                    </AnswerItem>
                    <VMVAContent>{strategy.success}</VMVAContent>
                    <LaunchButton onClick={() => {
                        setLaunch(true)
                    }}> Lancer le Coach Enjoy </LaunchButton>
                    {
                        launch &&
                        <>
                            <Assistant
                                context={{
                                    object: question,
                                }}
                                onSelect={(item) => {
                                    setSuccess(item.description);
                                }}
                                fromCoach={true}
                                setClose={setCloseAssistant}
                                adjust={adjust}
                            />
                            {
                                closeAssistant &&
                                <StrategyFormForCoach close={closeTest} value={question} content={success}/>
                            }
                        </>
                    }

                </VMVA>
            }
            {
                question === "duty" &&

                <VMVA>
                    <AnswerItem>
                        <h1 onClick={() => {
                            setQuestion("VMVA")
                        }}>&#8592;</h1>
                        <h2> Mission </h2>
                    </AnswerItem>
                    <VMVAContent> {strategy.mission} </VMVAContent>
                    <LaunchButton onClick={() => {
                        setLaunch(true)
                    }}>Lancer le Coach Enjoy</LaunchButton>
                    {
                        launch &&

                        <>
                            <Assistant
                                context={{
                                    object: question,
                                }}
                                onSelect={(item) => {
                                    setDuty(item.description);
                                }}
                                fromCoach={true}
                                setClose={setCloseAssistant}
                                adjust={adjust}
                            />
                            {
                                closeAssistant &&
                                <StrategyFormForCoach close={closeTest} value={question} content={duty}/>
                            }
                        </>
                    }

                </VMVA>
            }
            {
                question === "vision" &&

                <VMVA>
                    <AnswerItem>
                        <h1 onClick={() => {
                            setQuestion("VMVA")
                        }}>&#8592;</h1>
                        <h2> Vision </h2>
                    </AnswerItem>
                    <VMVAContent> {strategy.vision} </VMVAContent>
                    <LaunchButton onClick={() => {
                        setLaunch(true)
                    }}> Lancer le Coach Enjoy </LaunchButton>
                    {
                        launch &&

                        <>
                            <Assistant
                                context={{
                                    object: question,
                                }}
                                onSelect={(item) => {
                                    setVision(item.description);
                                }}
                                fromCoach={true}
                                setClose={setCloseAssistant}
                                adjust={adjust}
                            />
                            {
                                closeAssistant &&
                                <StrategyFormForCoach close={closeTest} value={question} content={vision}/>
                            }
                        </>
                    }
                </VMVA>
            }
            {
                question === "goal" &&

                <VMVA>
                    <AnswerItem>
                        <h1 onClick={() => {
                            setQuestion("VMVA")
                        }}>&#8592;</h1>
                        <h2> Ambition </h2>
                    </AnswerItem>
                    <VMVAContent> {strategy.goal} </VMVAContent>
                    <LaunchButton onClick={() => {
                        setLaunch(true)
                    }}> Lancer le Coach Enjoy </LaunchButton>
                    {
                        launch &&
                        <>
                            <Assistant
                                context={{
                                    object: question,
                                }}
                                onSelect={(item) => {
                                    setGoal(item.description);
                                }}
                                fromCoach={true}
                                setClose={setCloseAssistant}
                                adjust={adjust}
                            />
                            {
                                closeAssistant &&
                                <StrategyFormForCoach close={close} value={question} content={goal}/>
                            }
                        </>
                    }
                </VMVA>
            }
        </AnswerContainer>
    );
};

const AnswerContainer = styled.div`
    padding: 0.5rem;
`
const PlaceholderCoachEnjoy = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    text-align: center;
    h2{
        font-size: 1.5rem;
        color: var(--color-purple);
    }
    .img-placeholder{
        max-width: 70%;
        margin: auto;
        align-self: center;
        border-radius: 15px;
    }
`
const AnswerItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 1rem;
  img{
    width: 28px;
    height: 28px;
  } 
  p{
    font-size: calc(6px + (0.8vw));
  }
  h2{
      font-size: calc(9px + (0.8vw));
  }  
  
  :hover{
    cursor: pointer;
  }
`

const Questions = styled.p`
    font-size: calc(10px + (0.8vw));
    padding: 0.6rem;
    color: var(--color-purple);
`

const LaunchButton = styled.button`
    border: none;
    padding: 0.8rem;
    font-size: 1rem;
    border-radius: 12px;
    color: white;
    background-color: var(--color-purple);
    align-self: center;
    cursor: pointer;
`

const AnswerItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 130px;
`
const VMVAContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(100px, 500px));
    grid-template-rows: repeat(2, minmax(50px, 200px));
    gap: 1rem;
    margin-top: 2rem;
`
const VMVAItem = styled.div`
    text-align: center;
    cursor: pointer;
    margin: 2rem 0;
    p{
        font-size: 1.5rem;
    }
`
const VMVA = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`
const VMVAContent = styled.p`
    white-space: pre-line;
    font-size: 1rem;
    padding: 1rem;
    border-radius: 15px;
    box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.2);
`
export default CoachEnjoyAnswer;